import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/countries/profile/loading';

export const Route = createFileRoute('/_private/settings/countries/$id')({
  pendingComponent: Loading,
});
